import { EyeOutlined } from "@ant-design/icons";
import { nanoid } from "@ant-design/pro-components";
import {
  Affix,
  Col,
  Drawer,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
  Space,
  Spin,
  Upload,
  message,
} from "antd";
import ImgCrop from "antd-img-crop";
import { RcFile, UploadFile, UploadProps } from "antd/lib/upload";
import BoxContainer from "base/ui/components/BoxContainer";
import CustomButton from "base/ui/components/Button";
import CustomRadio from "base/ui/components/CustomRadio";
import { observer } from "mobx-react";
import Session from "pages/khaosat/Session/session";
import {
  Question,
  QuestionType,
  SessionMetadata,
  Session as SessionModel,
} from "pages/khaosat/models";
import { useEffect, useState } from "react";
import { surveyPresenter, surveyStore, uiStore } from "stores/root_store";
import { surveyValidation } from "utils/surveyHelper";
import PreviewModal from "../preview/PreviewModal";
import "../style.css";
import { cloneDeep } from "lodash";
import TextArea from "antd/es/input/TextArea";
import PageWrapper from "pages/Components/PageWrapper";
import { ROUTES } from "base/routes/routes";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Download } from "base/ui/components/Icons";
import { useCheckPermission } from "utils/permissionHelper";

type LayoutType = Parameters<typeof Form>[0]["layout"];

const uploadService = () => {
  return Promise.resolve("aaa");
};

export function addSurvey() {
  return observer(() => {
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [searchParams] = useSearchParams()
    const duplicate = searchParams.get('duplicate');
    const { id } = useParams();


    let pagetitle = "";
    if (id) {
      pagetitle = "Chỉnh sửa";
      useCheckPermission("EDIT");
    } else {
      pagetitle = "Thêm mới";
      useCheckPermission("CREATE");
    }

    const [formLayout, setFormLayout] = useState<LayoutType>("horizontal");
    const [form] = Form.useForm();
    const [formLastSession] = Form.useForm();
    const formItemLayout =
      formLayout === "horizontal"
        ? { labelCol: { span: 4 }, wrapperCol: { span: 14 } }
        : null;
    const buttonItemLayout =
      formLayout === "horizontal"
        ? { labelCol: { span: 4 }, wrapperCol: { span: 20 } }
        : null;
    const [sessionQues, setSessionQues] = useState<SessionModel[]>([
      {
        id: nanoid(),
        name: "Phần 1",
      },
    ]);

    const [fileList, setFileList] = useState<UploadFile[]>([]);
    // đóng mở modal
    const [open, setOpen] = useState(false);
    const [dataPreview, setDataPreview] = useState<{
      metaData: SessionMetadata;
      questions: SessionModel[];
    }>();

    const [image, setImage] = useState<string | undefined>(undefined);

    const [loading, setLoading] = useState(id ? true : false);
    // FUNCTIONS =================================================================================================
    const showDrawer = () => {
      setOpen(true);
    };

    const onClose = () => {
      setOpen(false);
    };

    // thêm phần =================================================================================================
    const handleAddSession = () => {
      const temp = cloneDeep(sessionQues);
      const session = {
        id: nanoid(),
        name: `Phần ${temp.length + 1}`,
      };
      temp.push(session);
      setSessionQues(temp);
      surveyPresenter.setSessions(session);
    };

    // Xem trước
    const handlePreview = () => {
      const event = new Event("previewSurvey");
      document.dispatchEvent(event);

      surveyValidation((data) => {
        showDrawer();

        setDataPreview({
          metaData: data.metadata,
          questions: Object.entries(data)
            .filter(
              ([key, value]) => key !== "metadata" && Object.keys(value).length
            )
            .map(([_, value]) => value),
        });
      });
    };

    // Lưu mẫu khảo sát ==========================================================================================
    const handleSave = (saveAndContinue: boolean, isEdit?: boolean) => {
      const event = new Event("previewSurvey");
      document.dispatchEvent(event);

      surveyValidation(async (data) => {
        const dataSections = Object.entries(data).filter(
          ([key, value]) => key !== "metadata" && Object.keys(value).length
        );

        const dataSave = {
          surveyName: data.metadata.title,
          description: data.metadata.description,
          aliasName: data.metadata.aliasName,
          actived: data.metadata.status,
          validDate: data.metadata.validDate,
          image: image
            ? image?.toString().replace("data:image/jpeg;base64,", "")
            : undefined,
          sections: dataSections.map(([_, value], index) => {
            const t: any = cloneDeep(value);
            const ques = {
              orderIndex: index,
              sectionName: value.title,
              description: value.description,
              sectionId: value.id,
              questions: t.questions.map((q: Question, index: number) => ({
                orderIndex: index,
                questionId: q.id,
                question: q.title,
                type: q.type,
                isScore: q.hasPoint,
                totalScore: !q.hasPoint
                  ? undefined
                  : q.type === "TN" || q.type === "RATE"
                    ? q.answers
                      ?.map((ans) => ans.score || 0)
                      ?.reduce((a, b) => (a > b ? a : b))
                    : q.answers
                      ?.map((ans) => ans.score || 0)
                      ?.reduce((a, b) => a + b),
                isRequired: q.required,
                answers: q.answers?.map((a, quesIndex) => ({
                  answerId: a?.id,
                  answer: a?.title + "",
                  score: a?.score,
                  orderIndex: quesIndex,
                  orderIndexSection: ((index) =>
                    index > 0 ? index : undefined)(
                      dataSections
                        .map(([_, value]) => value as any)
                        .findIndex((s) => s?.id === a?.part)
                    ),
                })),
              })),
            };
            return ques;
          }),
        };
        dataSave.sections.push({
          orderIndex: dataSave.sections.length,
          description: data.metadata.descriptionLast,
          sectionName: data.metadata.descriptionLast,
          sectionId: data.metadata.sectionIdLast,
          questions: undefined,
        });

        setLoading(true);
        if (!isEdit) {
          const result = await surveyPresenter.createSurvey(dataSave);

          // kiểm tra thành công hay không và hiện thông báo
          // Nếu thành công thì phải kiểm tra thêm là 'Lưu' hay 'Lưu và tiếp tục'
          if (result.isSuccess) {
            message.success(result.message);
            if (saveAndContinue) {
              // Trang Edit thì không reset field
              if (!id) {
                setSessionQues([
                  {
                    id: nanoid(),
                    name: "Phần 1",
                  },
                ]);
                form.resetFields();
              }
            } else navigate(ROUTES.SURVEY_TABLE.LINK);
          } else {
            message.error(result.message);
          }
        } else {
          const result = await surveyPresenter.editSurvey({
            ...dataSave,
            id: id
          });
          // kiểm tra thành công hay không và hiện thông báo
          // Nếu thành công thì phải kiểm tra thêm là 'Lưu' hay 'Lưu và tiếp tục'
          if (result.isSuccess) {
            message.success(result.message);
            if (saveAndContinue) {
              // Trang Edit thì không reset field
              if (!id) {
                setSessionQues([
                  {
                    id: nanoid(),
                    name: "Phần 1",
                  },
                ]);
                form.resetFields();
              }
            } else navigate(ROUTES.SURVEY_TABLE.LINK);
          } else {
            message.error(result.message);
          }
        }
        setLoading(false);
      });
    };

    // Cập nhật khảo sát =========================================================================================

    // =====================================================================================
    // handle set all forms and dispatch to survey preview =================================
    // =====================================================================================
    const handleSetSurvey = (event: Event): void => {
      const data = (event as CustomEvent).detail;
      surveyPresenter.setData(data);
    };

    const handleSetSurveyMetadata = () => {
      const event = new CustomEvent("setSurvey", {
        detail: { metadata: form },
      });
      document.dispatchEvent(event);
    };

    // tạo sự kiện
    useEffect(() => {
      surveyPresenter.resetSessions()
      document.addEventListener("previewSurvey", handleSetSurveyMetadata);
      document.addEventListener("setSurvey", handleSetSurvey);
      return () => {
        document.removeEventListener("previewSurvey", handleSetSurveyMetadata);
        document.removeEventListener("setSurvey", handleSetSurvey);
      };
    }, []);


    // LẤY DATA CHI TIẾT CỦA 1 FORM KHÁO SÁT DỰA TRÊN ID -----------------------------------------------------
    // LẤY DATA CHI TIẾT CỦA 1 FORM KHÁO SÁT DỰA TRÊN ID -----------------------------------------------------
    // LẤY DATA CHI TIẾT CỦA 1 FORM KHÁO SÁT DỰA TRÊN ID -----------------------------------------------------
    const getDetailSurvey = async () => {
      if (id || duplicate) {
        setLoading(true);
        const result = await surveyPresenter.getSurveyById(surveyStore, {
          id: duplicate ?? id ?? undefined,
        });
        if (surveyStore.surveyDetail) {
          // tạo các session
          const session: SessionModel[] = surveyStore.surveyDetail.sections.map(
            (s, index) => ({
              id: s.sectionId,
              name: `Phần ${surveyStore?.surveyDetail?.sections.length === index + 1 ? 'kết thúc' : index + 1}`,
              title: s.sectionName,
              description: s.description,
              questions: s.questions.map((q) => ({
                id: q.questionId,
                title: q.questionName,
                answers: q.answers?.map((a) => ({
                  id: a.answerId,
                  title: a.answer,
                  score: a.score,
                  part: a.sectionId,
                })),
                type: q.type as QuestionType,
                hasPoint: q.isScore,
                required: q.isRequired,
              })),
            })
          );

          // Lấy phần cuối (phần cảm ơn ) => Render riêng
          // Phần cảm ơn không nằm chung mảng với sesion
          const sessionFull = cloneDeep(session)
          const sessionLast = session.pop();
          // cập nhật sessionQues để render ra các session
          setSessionQues(session);

          // lấy tên khảo sát , mô tả , trạng thái , image để set value form
          const data = {
            title: surveyStore.surveyDetail.name,
            description: surveyStore.surveyDetail.description,
            descriptionLast: sessionLast?.title,
            sectionIdLast: sessionLast?.id,
            status: surveyStore.surveyDetail.actived,
            aliasName: surveyStore.surveyDetail.aliasName,
            validDate: surveyStore.surveyDetail.validDate,
          };
          form.setFieldsValue(data);
          if (surveyStore.surveyDetail.imageUrl) {
            setImage(surveyStore.surveyDetail.imageUrl);
            form.setFieldValue("image", [
              {
                uid: "-1",
                name: "image.png",
                status: "done",
                url: surveyStore.surveyDetail.imageUrl,
              },
            ]);
          }

          // lưu lại các phần để làm chuyển phần
          const sessionTemp = cloneDeep(session);
          // bỏ phần 1
          sessionTemp.shift();
          sessionFull.shift();


          if (sessionTemp.length) {
            sessionTemp.forEach((s) => {
              surveyPresenter.setSessions(s);
            });
          }
        } else {
          message.error(result.message);
        }
        setLoading(false);
      }
    };

    // gọi api lấy data
    useEffect(() => {
      getDetailSurvey();
    }, []);

    useEffect(() => {
      if (duplicate) {
        getDetailSurvey();
      }
    }, [duplicate])

    // Handle upload image ===================================================================================
    const onChange: UploadProps["onChange"] = async ({
      fileList: newFileList,
      file,
    }) => {
      if (newFileList.length) {
        setFileList(newFileList);
        let src = newFileList[0].url as string;
        if (!src) {
          src = await new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(newFileList[0].originFileObj as RcFile);
            reader.onload = () => resolve(reader.result as string);
          });
        }
        if (newFileList[0].type === 'image/png') {
          const newUrl = src.split(',')
          setImage(newUrl[1])
        } else {
          setImage(src);
        }

      } else {
        setFileList([]);
        setImage(undefined);
      }
    };

    const onPreview = async (file: UploadFile) => {
      let src = file.url as string;
      if (!src) {
        src = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(file.originFileObj as RcFile);
          reader.onload = () => resolve(reader.result as string);
        });
      }
      const image = new Image();
      image.src = src;
      const imgWindow = window.open(src);
      imgWindow?.document.write(image.outerHTML);
    };

    const customRequest = async (options: any) => {
      options.onProgress({ percent: 0 });
      const url = await uploadService();
      options.onProgress({ percent: 100 });
      options.onSuccess({}, { ...options.file, url });
    };

    const normFile = (e: any) => {
      if (Array.isArray(e)) {
        return e;
      }
      return e && e.fileList;
    };

    // handle delete section (xoá phần) =================================================================
    const handleDeleteSection = (idSession?: string) => {
      const tempt = cloneDeep(sessionQues);
      tempt.filter((i) => i.id !== idSession);
      setSessionQues(tempt.filter((i) => i.id !== idSession));
    };

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: "Form khảo sát",
            to: ROUTES.SURVEY_TABLE.LINK,
          },
          {
            text: pagetitle,
          },
        ]}
        extras={
          <>
            <CustomButton
              onClick={(e) => {
                if (!id) {
                  handleSave(false)
                } else {
                  handleSave(false, true)
                }
              }}
              type="default"
              icon={<Download className="!fill-black" />}
            >
              {t("btn.save")}
            </CustomButton>
            <CustomButton
              type="primary"
              onClick={() => {
                if (!id) {
                  handleSave(true)
                } else {
                  handleSave(true, true)
                }
              }}
              icon={<Download className="!fill-white" />}
            >
              {t("btn.save-update")}
            </CustomButton>
          </>
        }
      >
        {/* Màn hình thêm mới/sửa form khảo sát */}
        <BoxContainer className="!rounded-[3px] shadow-box">
          {/* Xử lý loading khi lưu */}
          {loading && (
            <div className=" fixed z-[100] inset-0 flex justify-center items-center h-screen w-screen bg-white/20">
              <Spin rootClassName=""></Spin>
            </div>
          )}
          <Form
            {...formItemLayout}
            form={form}
            style={{ maxWidth: formLayout === "inline" ? "none" : "100%" }}
            layout="horizontal"
            wrapperCol={{ offset: 5 }}
            initialValues={!id ? {
              validDate: 5
            } : {}}

          >
            <Row>
              <Col span={12} offset={12} className="!z-50">
                {/* THÊM PHẦN VÀ XEM TRƯỚC */}
                <Affix offsetTop={10}>
                  <div className="flex justify-end gap-2 ">
                    <CustomButton
                      type="primary"
                      title="Thêm phần"
                      onClick={handleAddSession}
                    >
                      Thêm phần
                    </CustomButton>
                    <CustomButton
                      title="Xem trước"
                      type="default"
                      icon={<EyeOutlined />}
                      onClick={handlePreview}
                    >
                      Xem trước
                    </CustomButton>
                  </div>
                </Affix>
              </Col>
              <Col className="mt-3 md:mt-[-25px]" md={12}>
                {/* Tên khảo sát */}
                <Form.Item
                  {...buttonItemLayout}
                  name={"aliasName"}
                  label="Tên khảo sát"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
                {/* Tiêu đề khảo sát */}
                <Form.Item
                  {...buttonItemLayout}
                  name={"title"}
                  label="Tiêu đề"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
                {/*Mô tả */}
                <Form.Item
                  {...buttonItemLayout}
                  name={"description"}
                  label="Mô tả"
                  rules={[{ required: true }]}
                >
                  <TextArea rows={2} />
                </Form.Item>
                {/* Trạng thái */}
                {id ? (
                  <Form.Item
                    {...buttonItemLayout}
                    className="!m-0"
                    name={"status"}
                    label="Trạng thái"
                  >
                    <Radio.Group>
                      <CustomRadio value={true}>Đang sử dụng</CustomRadio>
                      <CustomRadio value={false}>Ngưng sử dụng </CustomRadio>
                    </Radio.Group>
                  </Form.Item>
                ) : (
                  ""
                )}
              </Col>
              <Col className="mt-2 md:mt-[-25px]" md={12}>
                {/* Hình ảnh */}
                <Form.Item
                  {...buttonItemLayout}
                  name="image"
                  label="Hình ảnh"
                  labelCol={{ span: 4 }}
                  valuePropName="fileList"
                  getValueFromEvent={normFile}
                >
                  {/* <ImgCrop aspectSlider showGrid> */}
                  <Upload
                    listType="picture-card"
                    fileList={fileList}
                    onPreview={onPreview}
                    onChange={onChange}
                    maxCount={1}
                    showUploadList={{ showRemoveIcon: true }}
                    // beforeUpload={(file) => false} // return false so that antd doesn't upload the picture right away
                    customRequest={customRequest}
                    accept=".png,.jpg,.jpeg"
                  >
                    {/* <UploadOutlined /> */}
                    <div className="ant-upload-text">Upload</div>
                  </Upload>
                  {/* </ImgCrop> */}
                </Form.Item>

                <Form.Item
                  {...buttonItemLayout}
                  labelCol={{ span: 4 }}
                  name={'validDate'}
                  label={'Valid Date'}
                  className='col-span-1'
                  tooltip={'Số ngày hiệu lực (Tính từ ngày khách hàng nhận được tin nhắn Zalo, nếu quá số ngày hiệu lực sẽ không được phản hồi form khảo sát)'}

                >
                  <InputNumber
                    formatter={(value, info) => {
                      console.log(info);
                      return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    }
                    }
                    className='!w-[155px]'
                    addonAfter={'Ngày'} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </BoxContainer>

        {sessionQues.map((item, index) => {
          return (
            <Session
              key={item.id}
              index={index}
              sessionQues={item}
              handleDelete={handleDeleteSection}
            />
          );
        })}

        {/* ============================= FORM PHẦN CUỐI ========================== */}
        <div className="w-full flex flex-col rounded mb-2 relative flex-1 pt-[12px] px-4">
          <Form
            {...formItemLayout}
            form={form}
            className="!mt-8"
            style={{ maxWidth: formLayout === "inline" ? "none" : "100%" }}
            layout={formLayout}
          >
            <div className="rounded-lg relative">
              {/* Tên phần */}
              <div
                className={`bg-primary absolute top-[-30px] z-20 left-0 rounded-lg min-w-[128px] px-4 h-10 text-white flex items-center justify-center text-lg font-bold`}
              >
                Phần kết thúc
              </div>
              <div className="bg-primary rounded-tr-lg h-4"></div>
              <div className="p-3 md:p-3 bg-white !rounded-[3px] shadow-box">
                {/* mô tả */}
                <Form.Item
                  {...buttonItemLayout}
                  name="descriptionLast"
                  className="!mb-0 md:w-1/2"
                  label="Mô tả"
                  rules={[{ required: true }]}
                >
                  <TextArea
                    placeholder="Vui lòng nhập..."
                    className="w-full"
                    rows={3}
                  />
                </Form.Item>
                <Form.Item hidden name={'sectionIdLast'}><Input /></Form.Item>
              </div>
            </div>
          </Form>
        </div>

        {/* Survey Preview */}
        <Drawer
          title={
            <h2 className="font-medium text-[18px] p-0 leading-[26px] text-dark m-0 uppercase">
              Xem trước
            </h2>
          }
          placement={"top"}
          closable={false}
          onClose={onClose}
          open={open}
          height={"100%"}
          destroyOnClose
          className={`${uiStore.theme.name} [&_.ant-drawer-body]:!bg-primary/25 [&_.ant-drawer-body]:!px-2`}
          extra={
            <Space>
              <CustomButton type="primary" onClick={onClose}>
                Quay lại
              </CustomButton>
            </Space>
          }
        >
          <PreviewModal dataPreview={dataPreview} image={image} />
        </Drawer>
      </PageWrapper>
    );
  });
}
